import React from "react";
import { exportToExcel } from "../common";
import { List, Datagrid, TextField, useRecordContext } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";


const exporter = (payments) => {
  exportToExcel(payments, "support_tickets");
};

// Expand panel (optional, safe)
const MessagePanel = ({ record }) => {
  if (!record || !record.message) return null;
  return (
    <div
      style={{
        padding: "10px",
        background: "#fafafa",
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
      dangerouslySetInnerHTML={{ __html: record.message }}
    />
  );
};

// ✅ Function to call backend API
const updateMessageStatus = async (id, currentStatus) => {
  const newStatus = currentStatus === "open" ? "close" : "open";
  const token = localStorage.getItem("token");
  try {
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}admin/messages/${id}/status`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({ status: newStatus }),
    });
    if (!res.ok) throw new Error("Failed to update status");
    alert(`Status updated to "${newStatus}"`);
    window.location.reload();
  } catch (err) {
    console.error(err);
    alert("Error updating status");
  }
};

// ✅ Custom field to show status + edit icon
const StatusWithEditIcon = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <span>{record.status}</span>
      {/* <IconButton
        size="small"
        onClick={() => updateMessageStatus(record._id, record.status)}
        title="Edit Status"
      >
        <EditIcon fontSize="small" />
      </IconButton> */}
    </div>
  );
};

export default (props) => {
  const navigate = useNavigate();

  return (
    <List exporter={exporter} bulkActionButtons={false} {...props}>
      <Datagrid
        rowClick={(record) => {
          // record is the full row data
          if (record && (record._id || record.id)) {
            navigate(`/messages/${record._id || record.id}`);
          }
        }}
      >
        <TextField sortable={false} source="name" />
        <TextField sortable={false} source="email" />
        <TextField sortable={false} source="subject" />
        <StatusWithEditIcon label="Status" />
        <TextField sortable={false} source="receivedOn" />
      </Datagrid>
    </List>
  );
};
